
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  accountProfileName: {
    id: "AccountProfile.name",
    defaultMessage: "Name",
  },
  accountProfileTelephone: {
    id: "AccountProfile.telephone",
    defaultMessage: "Telephone number",
  },
  accountProfileStreet: {
    id: "AccountProfile.street",
    defaultMessage: "Street",
  },
  accountProfileZip: {
    id: "AccountProfile.zip",
    defaultMessage: "ZIP",
  },
  accountProfileSurname: {
    id: "AccountProfile.surname",
    defaultMessage: "Surname",
  },
  accountProfileMobile: {
    id: "AccountProfile.mobile",
    defaultMessage: "Mobile number",
  }, 
  accountProfileCity: {
    id: "AccountProfile.city",
    defaultMessage: "City",
  },
  accountProfileCountry: {
    id: "AccountProfile.country",
    defaultMessage: "Country",
  },
  accountProfileUserButton: {
    id: "AccountProfile.userbutton",
    defaultMessage: "Edit Form",
  },
  accountProfileEmail: {
    id: "AccountProfile.email",
    defaultMessage: "Email address",
  }, 
  accountProfilePassword: {
    id: "AccountProfile.password",
    defaultMessage: "Password",
  }, 
  accountProfileLoginButton: {
    id: "AccountProfile.loginbutton",
    defaultMessage: "Edit Form",
  }, 
  accountProfileHeadline: {
    id: "AccountProfile.headline",
    defaultMessage: "Login & Security",
  }, 
  accountProfileButton: {
    id: "AccountProfile.button",
    defaultMessage: "Save",
  },
});

export default MESSAGES;